import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: var(--width, 100%);
    height: var(--height, 100%);
    background: var(--skeleton-background-color);
    border-radius: var(--sds-size-radius-400);
    position: relative;
    overflow: hidden;
  }

  :host([elevation="0"]) {
    --skeleton-background-color: var(--sds-color-background-default-tertiary);
  }

  :host([elevation="1"]) {
    --skeleton-background-color: var(--sds-color-background-default-secondary);
  }

  :host([elevation="2"]) {
    --skeleton-background-color: var(--sds-color-background-default-default);
  }

  /* Default fallback for elevation 0 */
  :host {
    --skeleton-background-color: var(--sds-color-background-default-tertiary);
  }

  .content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-300) var(--sds-size-space-400);
    box-sizing: border-box;
  }

  .shimmer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    pointer-events: none;
  }

  .shimmer::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      color-mix(in hsl, var(--sds-color-background-neutral-secondary), transparent 50%),
      transparent
    );
    animation: shimmer 1.5s ease infinite;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(200%);
    }
  }
`;
